/* eslint-disable */
import { Link } from "react-router-dom";
import * as url from "helper/UrlHelper";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import downloadFileHandler from "helper/DownloadFile";

const GroupDetailsView = ({ groupData, memberStatus, t }) => {
  return (
    <div className="mt-3 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
      <div
        className={`details_info_heading d-flex align-items-center justify-content-between ${
          memberStatus.status === "1" ? "mb-4" : ""
        }`}
      >
        <h2 className="fw-bold mb-0 text-black">{groupData.title}</h2>
        {memberStatus.status === "1" &&
          memberStatus.modStatus === "1" &&
          memberStatus.joinDate && (
            <p className="fs-md mb-0 text-black">
              {t("Joined date")} -{" "}
              {getDateFormatInSpanish(memberStatus.joinDate)}
            </p>
          )}
      </div>

      {memberStatus.status !== "1" && memberStatus.inviteDate && (
        <div className="d-flex justify-content-end mt-1 mb-4">
          <p className="fs-md mb-0 text-black">
            {t("Invitation sent on")} -{" "}
            {getDateFormatInSpanish(memberStatus.inviteDate)}
          </p>
        </div>
      )}

      {groupData.image && (
        <ul className="preview-uploaded-files d-flex flex-wrap gap-2 mb-4 mt-2">
          <li className="file border border-gray rounded-8 overflow-hidden position-relative">
            <img
              src={
                groupData.image == ""
                  ? "https://placehold.co/150x150"
                  : url.SERVER_URL + groupData.image
              }
              alt="Uploaded"
              className="w-100 h-100 object-fit-cover object-center"
            />
          </li>
        </ul>
      )}

      {groupData.summary && (
        <div className="descriptiion_bx mb-4">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Summary")}</h4>
          <p className="mb-4 text-black fs-md">{groupData.summary}</p>
        </div>
      )}

      {groupData.details && (
        <div className="descriptiion_bx mb-4">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Description")}</h4>
          <div
            className="mb-4 text-black fs-md"
            dangerouslySetInnerHTML={{ __html: groupData.details }}
          />
        </div>
      )}

      {groupData.documents.length > 0 && (
        <div className="documents">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Documents")}</h4>
          <ul className="uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3">
            {groupData.documents.map((file, index) => {
              return (
                <li
                  className="file d-flex gap-3 align-items-center px-3 py-2 border border-gray rounded-3"
                  key={index}
                >
                  <p className="fw-medium">{file.name}</p>

                  <Link to="#" onClick={() => downloadFileHandler(file)}>
                    <span className="d-block material-symbols-outlined">
                      download
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default GroupDetailsView;
